import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { PlanStockManagementContainer } from "@/components/features/items/stock/plan/ui";

import { useGetPlanStockPageParams } from "./_hooks/use-get-plan-stock-page-params";

export const PlanStockPage = () => {
	const { hotelID } = useGetPlanStockPageParams();

	return (
		<PageMeta title="プラン在庫の設定" url={generatePath(PATHS.HOTEL.ITEMS.PLAN.STOCK, { hotelID })}>
			<PlanStockManagementContainer hotelID={hotelID} />
		</PageMeta>
	);
};
